// extracted by mini-css-extract-plugin
module.exports = {"patientCol":"Table_patientCol__2R_R6"};